import withAuthentication from '@/hooks/withAuthentication';
import React from 'react'
import styled from 'styled-components';
import SurveyTable from './SurveyTable';

const Survey = () => {
  return (
    <SurveyView>
      <TitleView>
        <h3>Surveys</h3>
        <p>
          Manage surveys by creating and updating survey for certain purposes
        </p>
      </TitleView>
      <SurveyTable />
    </SurveyView>
  );
}

export default withAuthentication(Survey);

const SurveyView = styled.div`
  width: 100%;
  margin-top: 2rem;
`;

const TitleView = styled.div`
  margin-bottom: 30px;

  h3 {
    font-size: 1.2rem;
    font-weight: 500;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.colors?.secondary};
  }

  p {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors?.activeTitle};
    max-width: 50%;
  }
`;